// public/js/components/toast-manager.js

const TOAST_STYLES = {
  success: {
    bg: 'bg-emerald-100',
    text: 'text-emerald-800',
    iconColor: 'text-emerald-600',
    border: 'border-emerald-500',
    icon: 'check',
  },
  error: {
    bg: 'bg-red-100',
    text: 'text-red-800',
    iconColor: 'text-red-600',
    border: 'border-red-500',
    icon: 'alert-circle',
  },
  info: {
    bg: 'bg-slate-200',
    text: 'text-slate-800',
    iconColor: 'text-slate-600',
    border: 'border-slate-500',
    icon: 'info',
  },
};

export class ToastManager {
  constructor() {
    this.container = document.getElementById('toast-container');
    if (this.container) {
      window.toastManager = this;
    }
  }

  show(message, type = 'info', duration = 3000) {
    if (!this.container) return;

    const style = TOAST_STYLES[type] ?? TOAST_STYLES.info;
    const role = type === 'error' ? 'alert' : 'status';

    const toast = document.createElement('div');
    toast.className = `toast p-4 border rounded-lg flex items-center space-x-3 max-w-sm transition-all duration-300 opacity-0 translate-y-2 transform ${style.bg} ${style.text} ${style.border}`;
    toast.setAttribute('role', role);
    toast.setAttribute('aria-live', 'polite');

    toast.innerHTML = `
      <i data-lucide="${style.icon}" class="h-5 w-5 ${style.iconColor} flex-shrink-0"></i>
      <p class="text-sm font-semibold flex-grow">${message}</p>
      <button class="ml-2 p-1 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-600 ${style.text} hover:bg-black/5 cursor-pointer" aria-label="Close notification">
        <i data-lucide="x" class="h-4 w-4"></i>
      </button>
    `;

    this.container.appendChild(toast);

    // Initialize icons if bundle is ready
    if (window.lucide && typeof window.lucide.createIcons === 'function') {
      window.lucide.createIcons({ root: toast });
    }

    // Trigger enter animation next frame
    requestAnimationFrame(() => {
      toast.classList.remove('opacity-0', 'translate-y-2');
    });

    const timer = setTimeout(() => {
      this.dismiss(toast);
    }, duration);

    const closeButton = toast.querySelector('button');
    closeButton?.addEventListener('click', () => {
      clearTimeout(timer);
      this.dismiss(toast);
    });
  }

  dismiss(toast) {
    if (!toast.isConnected) return;

    toast.classList.add('opacity-0', '-translate-y-2');
    
    // Remove after transition finishes
    toast.addEventListener('transitionend', () => {
      if (toast.isConnected) toast.remove();
    }, { once: true });
    
    // Safety fallback
    setTimeout(() => {
      if (toast.isConnected) toast.remove();
    }, 400); 
  }
}